import actionTypes from '../constants/action-types';

const setLoadedStatus = (value) => ({
  type: actionTypes.SET_LOADED_STATUS,
  payload: value,
});

export default setLoadedStatus;
